
export type DeviceManagementType = 'self_managed' | 'chaver_managed' | 'org_managed';

export const getDeviceManagementTypeLabel = (type: DeviceManagementType): string => {
  switch (type) {
    case 'self_managed':
      return 'Standard';
    case 'chaver_managed':
      return 'Child';
    case 'org_managed':
      return 'Organization Member';
    default:
      return 'Unknown';
  }
};

export const getDeviceManagementTypeBadgeVariant = (type: DeviceManagementType) => {
  switch (type) {
    case 'self_managed':
      return 'default' as const;
    case 'chaver_managed':
      return 'secondary' as const;
    case 'org_managed':
      return 'outline' as const;
    default:
      return 'outline' as const;
  }
};

// User Identity Types
export type UserIdentityType = 'parent' | 'child' | 'mentor' | 'mentee' | 'self-managed' | 'self_managed';

export const getUserIdentityLabel = (identity: string): string => {
  const normalizedIdentity = identity?.toLowerCase().replace(/_/g, '-');
  
  switch (normalizedIdentity) {
    case 'parent':
      return 'Parent';
    case 'child':
      return 'Child';
    case 'mentor':
      return 'Mentor';
    case 'mentee':
      return 'Mentee';
    case 'self-managed':
      return 'Self Managed';
    default:
      return identity || 'Unknown';
  }
};

export const getUserIdentityBadgeVariant = (identity: string) => {
  const normalizedIdentity = identity?.toLowerCase().replace(/_/g, '-');
  
  switch (normalizedIdentity) {
    case 'parent':
      return 'default' as const;
    case 'child':
      return 'secondary' as const;
    case 'mentor':
      return 'outline' as const;
    case 'mentee':
      return 'outline' as const;
    case 'self-managed':
      return 'default' as const;
    default:
      return 'outline' as const;
  }
};
